import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentCRM: null,           // "qwik_it" | "qwik_medic"
  crmPermissions: [],         // ["qwik_it", "qwik_medic"]
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserCRM: (state, action) => {
      const { crm_permissions, default_crm } = action.payload;

      state.crmPermissions = crm_permissions || [];

      // validate default crm
      if (
        default_crm &&
        state.crmPermissions.includes(default_crm)
      ) {
        state.currentCRM = default_crm;
      } else {
        state.currentCRM = state.crmPermissions[0] || null;
      }
    },

    switchCRM: (state, action) => {
      const crm = action.payload;
      if (state.crmPermissions.includes(crm)) {
        state.currentCRM = crm;
      }
    },

    resetUserCRM: () => initialState,
  },
});

export const {
  setUserCRM,
  switchCRM,
  resetUserCRM,
} = userSlice.actions;

export const selectCurrentCRM = state => state.user.currentCRM;
export const selectCRMPermissions = state => state.user?.crmPermissions;

export default userSlice.reducer;
